import { z } from 'zod';

export const loomContentTypeSchema: z.ZodNativeEnum<{
	readonly Video: 'video';
	readonly AsyncVideo: 'async-video';
	readonly MeetingRecording: 'meeting-recording';
	readonly Playlist: 'playlist';
	readonly Tag: 'tag';
	readonly Space: 'space';
	readonly Folder: 'folder';
}> = z.nativeEnum({
	Video: 'video',
	AsyncVideo: 'async-video',
	MeetingRecording: 'meeting-recording',
	Playlist: 'playlist',
	Tag: 'tag',
	Space: 'space',
	Folder: 'folder',
} as const);
